/* global isyMap */
define(['components/utilities/utilities'], function (utils) {
	'use strict';

	/**
	 * AstOlMap
	 * A plugin that integrates with the AstOlMap.
	 * @exports isymap
	 */
	var isymap = {

		/** Placeholder for base DOM element. */
		el: null,

		/** Element id for map */
		mapId: null,

		/** Integer value for zoom in map */
		zoom: null,

		/** Initial camera coords for map */
		cameraCoords: null,

		/** Map layers */
		layers: '',

		/** Facilities to display on map */
		facilities: null,

		/** Reference for the IsyMap instance */
		map: null,

		/** A custom map layer */
		customLayer: null,

		/** The kommundelar_2018 layer to get area for layers from */
		kommundelar: null,

		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function (el) {
			this.el = el;
			this.mapId = el.getAttribute('id');
			this.zoom = el.getAttribute('data-zoom');
			this.cameraCoords = JSON.parse(el.getAttribute('data-camera-coords'));
			this.layers = el.getAttribute('data-layers');
			this.facilities = JSON.parse(el.getAttribute('data-facilities'));

			this._initiateIsyMap();
		},


		/**
		 * Initiate IsyMap on element node
		 */
		_initiateIsyMap: function () {
			var that = this;

			window.initMap = function () {
				that.map = new window.isymap(that.mapId);
				that.map.Init();

				var customInit = function () {
					that._getLayer('kommundelar_2018');

					that.map.SelectTool('infoTool');
					that.customLayer = that.map.AddLayer({
						ID: 'anlaggningar',
						DisplayName: 'Anläggningar',
						VectorConnectionName: 'local', // Use local for client layers i.e. layers that are not present on the server.
						RasterStartZoomLevel: -1, // Use -1 for vector data only.
						//SldFilename: 'mySldFileName', // The name of the SLD file in the library collection.
						FeatureIdProperty: 'Namn', // The name of the unique identifier.
						Visible: true, // Visibility.
						ShowInLayerControl: true, // If the layer will be present in the layer control or not.
						IsLeaf: true // Indicates that the layer is a single leaf in the layer control, not part of any group.
					});

					that._addFeatures();

					if (that.layers) {
						var splitLayers = that.layers.split(',');

						utils.forEach(splitLayers, function (layer, i) {
							that._getLayer(layer);
						});
					}

					if (that.zoom && that.cameraCoords) {
						that.map.ZoomTo(that.zoom);
						that.map.PanTo(that.cameraCoords.x, that.cameraCoords.y);
					} else {
						var customFeatures = that.map.GetFeatures(that.customLayer.ID);

						if (!that.layers) {
							that._updateBounds(customFeatures, true);
						} else {
							that._updateBounds(customFeatures, false);
							var mapLayers = that.layers.split(',');

							utils.forEach(mapLayers, function (layer, i) {
								if (i < (mapLayers.length - 1)) {
									that.map.SearchFeatures(layer, '', null, function (features) { that._updateBounds(features, false); });
								} else {
									that.map.SearchFeatures(layer, '', null, function (features) { that._updateBounds(features, true); });
								}
							});
						}
					}
				};

				that.map.Event.Bind(that.map.Event.Types.MapLoaded, customInit);
			};
		},


		/**
		 * Adds custom features/facilities to map
		 */
		_addFeatures: function () {
			var that = this;

			if (this.facilities && this.facilities.length > 0) {
				utils.forEach(this.facilities, function (facility) {
					that.map.AddFeatures(that.customLayer.ID, [
						{
							attributes: {
								Namn: facility.attributes.Namn,
								mråde: facility.Area,
								Typ: facility.Type
							},
							wkt: facility.wkt,
							layerId: that.customLayer.ID,
							styleExtensions: {
								pointRadius: facility.styleExtensions.pointRadius,
								fillColor: facility.styleExtensions.fillColor,
								strokeColor: facility.styleExtensions.strokeColor
							}
						}
					], 'EPSG:3011');
				});

				this._waitForKommundelarToLoad();
			}
		},


		/**
		 * Waits for the 'kommundelar_2018' layer to have loaded before adding custom facilities to list
		 * If we don't wait for the layer, we won't be able to get the area the facility is in
		 */
		_waitForKommundelarToLoad: function () {
			var that = this;

			if (this.kommundelar) {
				this._addFacilitiesToList(this.facilities);
			} else {
				setTimeout(function () { that._waitForKommundelarToLoad(); }, 500);
			}
		},


		/**
		 * Updates map to fit bounds from features
		 * @param {Array} features - Array of feature objects
		 * @param {Boolean} zoomToExtent
		 */
		_updateBounds: function (features, zoomToExtent) {
			var minX = 9007199254740991,
				minY = 9007199254740991,
				maxX = 0,
				maxY = 0;

			utils.forEach(features, function (feature) {
				if (feature.wkt) {
					var substringStart = feature.wkt.indexOf('('),
						substringEnd = feature.wkt.indexOf(')');

					if (substringStart && substringEnd) {
						var rawCoordinates = feature.wkt.substring(substringStart + 1, substringEnd),
							coordinates = rawCoordinates.split(' '),
							x = parseInt(coordinates[0]),
							y = parseInt(coordinates[1]);

						if (x < minX) {
							minX = x;
						}
						if (x > maxX) {
							maxX = x;
						}
						if (y < minY) {
							minY = y;
						}
						if (y > maxY) {
							maxY = y;
						}
					}
				}
			});

			if (zoomToExtent) {
				this.map.ZoomToExtent([minX, minY, maxX, maxY], 10, 5);
				this.map.Resize();
			}
		},


		/**
		 * Gets, loads and initiates a layer
		 * @param {String} layerName - The name of the layer to get
		 */
		_getLayer: function (layerName) {
			var layer = this.map.GetLayer(layerName);
			layer.InitChildLayers();
			layer.LoadAllFeatures();
			this._waitForFeaturesToLoad(layer, layerName, layerName === 'kommundelar_2018');
		},


		/**
		 * Waits for layer features to load properly before working with it
		 * @param {Object} layer - The loaded layer
		 * @param {String} layerName - The string layer name
		 * @param {Boolean} kommundelar - true/false, if current layer is the 'kommundelar_2018' layer
		 */
		_waitForFeaturesToLoad: function (layer, layerName, kommundelar) {
			var that = this,
				layerHasFeatures = this.map.GetFeatures(layer.ID).length > 0;

			if (layerHasFeatures && this.kommundelar || layerHasFeatures && kommundelar && !this.kommundelar) {
				var layerFeatures = this.map.GetFeatures(layer.ID);

				if (kommundelar) {
					this.kommundelar = layer;
				} else if (this.kommundelar) {
					this.map.ShowLayer(layerName);
					this._addFacilitiesToList(layerFeatures);
				}
			} else {
				setTimeout(function () { that._waitForFeaturesToLoad(layer, layerName, kommundelar); }, 500);
			}
		},


		/**
		 * Adds facilities to list on page
		 * @param {Array} facilities - An array of facility objects
		 */
		_addFacilitiesToList: function (facilities) {
			var containerEl = document.getElementById('plant-list'),
				template = document.getElementById('facility-row'),
				that = this;

			if (containerEl) {
				utils.forEach(facilities, function (facility) {
					var name = facility.attributes.Namn || facility.attributes.Plannamn || facility.attributes.namn;

					if (!name) {
						console.log('WARNING: Facility has no name: \n' + JSON.stringify(facility));
						return;
					}

					var kommundel;
					if (that.map && that.kommundelar) {
						kommundel = that.map.GetFeatures(that.kommundelar.ID, 'CONTAINS(' + that.kommundelar.GeometryProperty + ', ' + facility.wkt + ')')[0];
					}

					var clonedTemplate = document.importNode(template.content, true);

					clonedTemplate.querySelector('a').textContent = name;
					clonedTemplate.querySelector('a').setAttribute('href', (facility.attributes.url || facility.attributes.lank_sida));
					clonedTemplate.querySelector('p').textContent = kommundel && kommundel.attributes ? kommundel.attributes.namn : '';

					containerEl.appendChild(clonedTemplate);
				});
			}
		}
	};

	return isymap;
});



//////////////////
// WEBPACK FOOTER
// ./components/isymap/isymap.js
// module id = 21
// module chunks = 6